import { render, staticRenderFns } from "./WordsOfWisdomPost.vue?vue&type=template&id=48283008&"
import script from "./WordsOfWisdomPost.vue?vue&type=script&lang=js&"
export * from "./WordsOfWisdomPost.vue?vue&type=script&lang=js&"
import style0 from "./WordsOfWisdomPost.vue?vue&type=style&index=0&id=48283008&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports